export default "__VITE_ASSET__Du8lU0EK__"